export interface MovimientoTramite {
  id: number;
  tramite_id: number;
  asignado_id: number;
  success: boolean;
  fecha_completado: Date;
  observacion: string;
  estado_id: number;
}

export function createEmptyMovimientoTramite(): MovimientoTramite {
  return {
    id: null,
    tramite_id: null,
    asignado_id: null,
    success: null,
    fecha_completado: null,
    observacion: null,
    estado_id: null
  };
}

export function createMovimientoTramite(params: any): MovimientoTramite {
  return {
    ...createEmptyMovimientoTramite(),
    ...params
  };
}
